import { num } from "@/lib/format";
import { Badge } from "@/components/ui/badge";
import { Tips } from "@/components/marketing/MarketingTips";
import { AlertTriangle } from "lucide-react";

const FORMAT_CLS = { Reel: "border-primary/50 text-primary", Carosello: "border-sky-500/50 text-sky-400" };

const Slot = ({ s, testid }) => (
  <div className="rounded-md border border-border/60 p-3 text-xs" data-testid={testid}>
    <div className="mb-1 flex items-center justify-between gap-2">
      <span className="font-semibold">{s.day} · {s.time}</span>
      <Badge variant="outline" className={FORMAT_CLS[s.format]}>{s.format}</Badge>
    </div>
    <p className="text-sm font-medium">{s.idea}</p>
    <p className="mt-0.5 truncate" title={s.product}>{s.product}</p>
    <p className="mt-1 text-muted-foreground">{s.reason}</p>
  </div>
);

export const MarketingCalendar = ({ c }) => (
  <div className="space-y-5" data-testid="marketing-calendar">
    <p className="text-xs text-muted-foreground">
      Capi {c.season} più venduti negli ultimi 45 giorni{c.demand_total ? ` e più richiesti (${num(c.demand_total)} richieste Wishlist/Back in Stock)` : " · nessuna richiesta Wishlist/Back in Stock caricata: caricale in Richieste clienti per includere i capi più richiesti"}. Giorni e orari scelti in base alla copertura dei tuoi post.
    </p>
    <div className="grid grid-cols-1 gap-4 md:grid-cols-2 xl:grid-cols-4">
      {c.weeks.map((w) => (
        <div key={w.week} className="space-y-2" data-testid={`marketing-week-${w.week}`}>
          <p className="font-mono-erp text-[11px] uppercase tracking-widest text-muted-foreground">Settimana {w.week}</p>
          {w.slots.map((s, i) => <Slot key={`${s.day}-${s.product}`} s={s} testid={`marketing-week-${w.week}-slot-${i}`} />)}
        </div>
      ))}
    </div>
    <Tips tips={c.rules} testid="marketing-calendar-rules" />
    {c.low_stock.length > 0 && (
      <div className="rounded-lg border border-amber-500/40 bg-amber-500/5 p-4 text-sm" data-testid="marketing-low-stock">
        <p className="mb-2 flex items-center gap-1.5 font-mono-erp text-[11px] uppercase tracking-widest text-amber-400"><AlertTriangle className="h-3.5 w-3.5" />Vendono ma hanno poche scorte: non sponsorizzarli prima del riassortimento</p>
        {c.low_stock.map((p) => <p key={p.product} className="text-xs">{p.product} · {num(p.sold)} venduti · <span className="text-amber-400">{num(p.stock)} in magazzino</span></p>)}
      </div>
    )}
  </div>
);
